import { get } from '../ApiClient';
import { DefaultApiResponse } from '../models/response/DefaultApiResponse';
import { fetchApiData } from '../ApiHelper';
import EndpointProps from 'interface/EndpointProps';

export interface WorkspaceFlagData {
    key: string;
    enabled: boolean;
}

export interface WorkspaceFlagResult {
    success: boolean;
    enabled: boolean;
    error: string | null;
}

export async function fetchWorkspaceFlag({ tag }: EndpointProps): Promise<WorkspaceFlagResult> {
    const result = await fetchApiData<DefaultApiResponse<WorkspaceFlagData>>(
        tag,
        () => get<DefaultApiResponse<WorkspaceFlagData>>({ tag, url: '/flags/workspace_open' }),
        (responseData) => responseData.data ?? null,
    );

    if (result.response.status === 'success' && result.response.data) {
        return { success: true, enabled: result.response.data.enabled, error: null };
    }

    return { success: false, enabled: false, error: result.response.message ?? 'Unknown error' };
}